import type { FC } from 'react';
import styled, { css } from 'styled-components';
import { useSlider } from '../SliderContext';
import { Bullets } from './bullets/Bullets';
import { alignToJustifyContent } from './constants';
import { Lines } from './lines/Lines';
import { Numbers } from './Numbers';
import type { PaginationProps, PaginationVariantBaseProps } from './types';

export const Pagination = ({
  type,
  currentIndex,
  slides,
  goTo,
  paginationClassName,
  seconds,
  animation,
  position,
  align,
  colors,
  customPagination,
  autoplayProgressBar,
  autoplayEnabled,
  autoplayPauseOnHover,
  loop
}: PaginationProps) => {
  const { appClassnamePrefix } = useSlider();

  const settings = {
    currentIndex,
    slides,
    goTo,
    paginationClassName,
    seconds,
    animation,
    position,
    align,
    colors,
    autoplayProgressBar,
    autoplayEnabled,
    autoplayPauseOnHover,
    loop
  };

  if (customPagination) {
    return customPagination(settings);
  }

  const PaginationVariant: FC<PaginationVariantBaseProps> = {
    bullets: Bullets,
    numbers: Numbers,
    lines: Lines
  }[type];

  return (
    <PaginationComponent _appClassPrefix={appClassnamePrefix} _align={align}>
      <PaginationVariant {...settings} />
    </PaginationComponent>
  );
};

interface PaginationComponentProps {
  _appClassPrefix: string;
  _align: string;
}

const PaginationComponent = styled.div.attrs<PaginationComponentProps>(
  ({ _appClassPrefix }) => ({
    className: `${_appClassPrefix}-pagination-component`
  })
)`
  display: flex;
  position: absolute;
  bottom: 0;
  z-index: 1;
  max-width: 100%;
  width: 100%;

  ${({ _align }) => {
    const justifyValue = alignToJustifyContent(_align, true);

    return css`
      ${justifyValue && `justify-content: ${justifyValue};`}
      ${_align === 'center' &&
      `
          left: 50%;
          transform: translateX(-50%);
        `}
    `;
  }}
`;
